"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyRegistrationNumberSchema = void 0;
var _zod = require("zod");
var companyRegistrationNumberSchema = t => {
  return _zod.z.object({
    companyRegNum: _zod.z.string().min(3, {
      message: t('payApplication.companyDetails.registeredNumber.failure.notification')
    })
  });
};
exports.companyRegistrationNumberSchema = companyRegistrationNumberSchema;